import React from 'react';
import { Wrench, Shield, GlassWater, Zap } from 'lucide-react';

const TopBar = () => {
  return (
    <div className="bg-[#1a2332] text-white py-2 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-4 md:gap-8 text-xs md:text-sm flex-wrap">
        <div className="hidden md:flex items-center gap-2">
          <Wrench className="w-4 h-4 text-blue-400" />
          <span>Pièces Premium testées</span>
        </div>
        <div className="flex items-center gap-2">
          <Shield className="w-4 h-4 text-blue-400" />
          <span>Garantie 3 mois</span>
        </div>
        <div className="hidden md:flex items-center gap-2">
          <GlassWater className="w-4 h-4 text-green-400" />
          <span>Réparation éco-responsable</span>
        </div>
        <div className="flex items-center gap-2">
          <Zap className="w-4 h-4 text-yellow-400" />
          <span>Réparé le jour même</span>
        </div>
      </div>
    </div>
  );
};

export default TopBar;